// extracted by mini-css-extract-plugin
export default {"card":"Filter_card__ZE9Mh","title":"Filter_title__LlxFR"};